// src/com/map/VehMapBox.js
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { styled  } from '@mui/material/styles';
import ValueMisc from '../../value/ValueMisc';
import { MapValue } from '../../value/AppConst';

const NM = window.naver.maps;
const SpeedEnough = 5;
export const MapID = 'homeplus_map';

class MapShell {
    posMarker = null;
    constructor(map) {
        this.map = map;
    }

    setCenter = (lat, lon, level) => {
        this.map.setCenter(new NM.LatLng(lat, lon));
        if(level) this.map.setZoom(level || 14);
    };

    putVehicle = (pos) => {
        const MarkerHeight = MapValue.POS_MARKER_SIZE + MapValue.MARKER_LABEL_HEIGHT;
        const MarkerAnchorX = MapValue.LABEL_CONTAINER_WIDTH / 2;

        let iconFile;
        if(pos.posSys==='C') iconFile = 'cellpos_w22.png';
        else {
                if(pos.speed < SpeedEnough) iconFile = 'stopped_22x22.png';
                else {
                    var dir = ValueMisc.degreeToIndex16(pos.direction % 360);
                    iconFile = 'arrow_' + dir + '.png';
                }
        }
        const iconUrl = MapValue.VEH_ICON_DIR + iconFile;


        this.posMarker = new NM.Marker({
            position: new NM.LatLng(pos.lat, pos.lon),
            userData: {
                type:MapValue.MarkerType.VEH_POS,
                data:pos,
            },
            map: this.map,
            icon: {
                content: 
                    `<div style="
                        z-index: ${MapValue.VEHPOS_Z_INDEX};
                        display: inline-block; font-size:8pt;
                        height:${MarkerHeight}px;
                        width:${MapValue.LABEL_CONTAINER_WIDTH}px;
                        text-align: center;">
                        <img src="${iconUrl}" style="width:22;height:22;" />
                        <div style="width:${MapValue.LABEL_CONTAINER_WIDTH}px;height: 24px;margin: 0px;">
                            <div style="
                                display:inline-flex; align-items:center;
                                padding-left:10px; padding-right:10px;
                                border-radius:3px;
                                box-shadow: 1px 1px 1px 1px #aaa;
                                background-color:red;color:white;
                                height:${MapValue.MARKER_LABEL_HEIGHT}px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                font-size: 14px;
                            ">
                                최종위치
                            </div>
                        </div>
                    </div>`,
                size: new NM.Size(MapValue.LABEL_CONTAINER_WIDTH, MarkerHeight),
                anchor: new NM.Point(MarkerAnchorX, MapValue.POS_MARKER_SIZE/2),
            },
            draggable: false,
            zIndex: MapValue.VEHPOS_Z_INDEX
        });
    };
}

export default function VehMapBox({
    mapData,
    height,
}) {
    const [mapShell, setMapShell] = useState(null);
    const [mapState, setMapState] = useState({ok:false, error: 'Waiting...'});
    const runRef = useRef(false);

    useEffect(() => {
        if(!runRef.current) {
            const mapBox = document.getElementById(MapID);
            if(!mapBox) {
                setMapState({ok:false, error: '지도 초기화 오류(MapBox not found)'});
                return;
            }
            const map = new window.naver.maps.Map(mapBox);
            const mapShell = new MapShell(map);
            mapShell.setCenter(mapData.lat, mapData.lon, 14);
            mapShell.putVehicle(mapData);
            setMapShell(mapShell);
            runRef.current = true;
        }
    }, []);

    return (
        <div id={MapID} style={{overflow:'hidden', height: height}}>
            {
                mapState.ok ? '' : mapState.error
            }
        </div>
    )
}